/* eslint-disable react/jsx-props-no-spreading */
import React, { ReactNode, memo } from 'react';

import Button, { ButtonSize, ButtonType } from '@zvuk-b2b/react-uikit/ui/Button';

import InputSearch, { InputSize } from '@zvuk-b2b/react-uikit/ui/InputSearch';
import { TEXTS } from 'application/pages/texts';
import styles from './index.module.scss';
import TagFilters, { TagFiltersProps } from '../MainToolbar/FiltersTool/TagFilters';
import { CompanyTagsListProps } from '../MainToolbar/FiltersTool/TagFilters/CompanyTagsList';

interface SimplyToolbarProps {
  createButtonTitle?: string;
  onButtonClick: () => void;
  isDisabled?: boolean;
  ButtonPrefix?: ReactNode;
  ButtonSuffix?: ReactNode;
  showButton?: boolean;
  withSearch?: boolean;
  searchValue?: string;
  isSearchLoading?: boolean;
  searchInputPlaceholder?: string;
  onSearchChange?: (search: string) => void;
  withTags?: boolean;
  tagsProps?: TagFiltersProps;
  onSetCompanyListTagsProps?: (companyListProps: Partial<CompanyTagsListProps>) => void;
}

const SimplyToolbar: React.FC<SimplyToolbarProps> = ({
  createButtonTitle,
  onButtonClick,
  isDisabled,
  ButtonPrefix,
  withSearch,
  searchValue,
  isSearchLoading,
  searchInputPlaceholder = TEXTS.INPUT_SEARCH_PLACEHOLDER,
  onSearchChange,
  ButtonSuffix,
  showButton = true,
  withTags = false,
  tagsProps,
  onSetCompanyListTagsProps,
}) => (
  <div className={styles.SimplyToolbar}>
    <div className={styles.left}>
      {withSearch && (
        <InputSearch
          elementId="toolbar_input_search"
          size={InputSize.SMALL}
          value={searchValue}
          isSearchLoading={isSearchLoading}
          placeholder={searchInputPlaceholder}
          containerClassName={styles.simplyToolbarInput}
          onChange={onSearchChange}
        />
      )}
      {withTags && tagsProps && (
        <div className={styles.filters}>
          <TagFilters
            {...tagsProps}
            withList={false}
            onSetCompanyListTagsProps={onSetCompanyListTagsProps}
          />
        </div>
      )}
    </div>
    {ButtonPrefix}
    {showButton && (
      <Button
        elementId="toolbar_button_add"
        size={ButtonSize.SMALL}
        type={ButtonType.PRIMARY}
        className={styles.SimplyToolbarButton}
        onClick={onButtonClick}
        isDisabled={isDisabled}>
        {createButtonTitle}
      </Button>
    )}
    {ButtonSuffix}
  </div>
);

export default memo(SimplyToolbar);
